import React from 'react'
import PropTypes from 'prop-types'

import Box from '@material-ui/core/Box'
import HotkeyButtonWrapper from './HotkeyButtonWrapper'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  buttonText: (styles) => ({
    paddingTop: '8px',
    paddingLeft: '8px',
    paddingRight: '8px',
    fontSize: styles.fontSize,
    fontWeight: 600,
    fontFamily: 'Montserrat',
    overflow: 'hidden'
  }),
  ageCheck: {
    paddingLeft: '8px',
    paddingBottom: '8px',
    '& img': {
      height: '24px'
    }
  },
  price: {
    textAlign: 'right',
    fontFamily: 'Fira Code',
    fontWeight: 300,
    fontSize: '14px',
    paddingBottom: '6px',
    paddingRight: '8px',
    overflow: 'hidden',
    '& .pricePounds': {
      fontSize: '20px', fontWeight: 400
    },
    '& .pricePence': {
      fontWeight: 400
    }
  }
})

export default function HotkeyProductButton (props) {
  const {
    width = 4,
    id,
    color = '',
    text,
    fontSize = 16,
    price,
    itemSize = '',
    ageRestriction,
    productId = null,
    onClick,
    selected = false
  } = props

  const classes = useStyles({ fontSize })

  const pricePounds = parseInt(price / 100)
  const pricePence = String(price % 100).padStart(2, '0')

  return (
    <HotkeyButtonWrapper selected={selected} width={width} accentColor={color} accent="left" onClick={(event) => onClick(event, id)}>
      <Box className={classes.buttonText} flex={3} display="flex" alignItems="start" color="#1e2552">
        {text}
        {
          // only display an item size if supplied
          itemSize && <>, {itemSize}</>
        }
      </Box>
      <Box className="buttonBottomRow" flex={2} display="flex" alignItems="flex-end">
        {
          ageRestriction &&
          <Box className={classes.ageCheck} flex={1} display="flex">
            <Box flex={1} display="flex" alignItems="flex-end">
              <img src={require(`../../assets/img/icons/ageCheck/${ageRestriction}.svg`)} />
            </Box>
          </Box>
        }
        <Box className={classes.price} flex={3}>
          <Box component="span">£</Box>
          {
            productId === null
              ? <></>
              // products with no price will not display price. We use span elements in the Box to get the elements to display inline next to each other
              : price === null
                ? <Box component="span" className="pricePence">Var</Box>
                : <>
                  <Box component="span" className="pricePounds">{pricePounds}</Box>
                  <Box component="span" className="pricePence">.{pricePence}</Box>
                </>
          }
        </Box>
      </Box>
    </HotkeyButtonWrapper>
  )
}

HotkeyProductButton.propTypes = {
  id: PropTypes.string.isRequired,
  width: PropTypes.number,
  text: PropTypes.string,
  fontSize: PropTypes.number,
  color: PropTypes.string,
  price: PropTypes.number,
  itemSize: PropTypes.string,
  ageRestriction: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  productId: PropTypes.string
}
